import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"
import ChartDataLabels from "chartjs-plugin-datalabels"
import { technologyGraphConfig } from "../lib/technology_graph"
import { productGraphConfig } from "../lib/product_graph"

Chart.register(...registerables)

export default class extends Controller {
  static targets = ["canvas"]
  static values = { report: Object, reportType: String }

  connect() {
    if (this.reportTypeValue === "TechnologyDashboardTile") {
      this.render(technologyGraphConfig(this.reportValue))
    } else {
      this.render(productGraphConfig(this.reportValue))
    }
  }

  render({ data, options }) {
    const ctx = this.canvasTarget.getContext("2d")

    new Chart(ctx, { plugins: [ChartDataLabels], type: "bar", data, options })
  }
}
